import { contratosVisibles } from './dominio.js';
import { S } from './estado.js';
import { esc } from './formato.js';
import { db } from '../data/db.js';

/* =====================================================================
   NAVEGACIÓN
   ===================================================================== */
export function menu(){
  const rol = S.usuario.rol;
  const cs = contratosVisibles().map(c=>c.id);
  const pedAbiertos = db.pedidos.filter(p=>cs.includes(p.contrato) && !['servido','anulado'].includes(p.estado)).length;
  const borradores = db.imputaciones.filter(i=>i.estado==='borrador').length;
  const items = [
    {v:'panel', t:'Panel', i:'M3 12h4l2-6 3 12 2-6h5', roles:['admin','operario','consulta']},
    {v:'contratos', t:'Contratos', i:'M5 3h9l4 4v14H5zM14 3v4h4', roles:['admin','operario','consulta']},
    {v:'imputaciones', t:'Imputaciones', i:'M4 6h16M4 12h16M4 18h10', roles:['admin','operario','consulta'], n:rol==='admin'?borradores:0},
    {v:'pedidos', t:'Pedidos', i:'M3 6h15l-1.5 9H5zM5 6 4 3H2M7 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2M16 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2', roles:['admin','operario','encargado','consulta'], n:pedAbiertos},
    {v:'certificaciones', t:'Certificaciones', i:'M5 3h14v18l-7-4-7 4z', roles:['admin','consulta']},
    {v:'informes', t:'Informes', i:'M4 20V9M10 20V4M16 20v-7M22 20H2', roles:['admin','operario','consulta']},
    {v:'usuarios', t:'Usuarios', i:'M16 20v-2a4 4 0 0 0-8 0v2M12 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7', roles:['admin']},
    {v:'ajustes', t:'Ajustes', i:'M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM19 12a7 7 0 0 0-.1-1.2l2-1.6-2-3.4-2.3.9a7 7 0 0 0-2-1.2L14 3h-4l-.4 2.5a7 7 0 0 0-2 1.2l-2.3-.9-2 3.4 2 1.6a7 7 0 0 0 0 2.4l-2 1.6 2 3.4 2.3-.9a7 7 0 0 0 2 1.2L10 21h4l.4-2.5a7 7 0 0 0 2-1.2l2.3.9 2-3.4-2-1.6a7 7 0 0 0 .1-1.2z', roles:['admin']},
  ].filter(i=>i.roles.includes(rol));
  return items.map(i=>`<a class="${S.vista===i.v?'on':''}" data-act="ir" data-v="${i.v}">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="${i.i}"/></svg>
    ${i.t}${i.n?`<span class="badge">${i.n}</span>`:''}</a>`).join('');
}

export function selectorContrato(cid){
  const cs = contratosVisibles();
  return `<div class="selector">
    <span class="et">Contrato</span>
    <select data-act="saltar-contrato">
      ${cs.map(c=>`<option value="${c.id}" ${c.id===cid?'selected':''}>${esc(c.expediente)} · ${esc(c.nombre)}${c.estado==='cerrado'?' (cerrado)':''}</option>`).join('')}
    </select>
    <span style="color:var(--gris-claro);font-size:12px;margin-left:auto">Cambia de contrato sin salir de esta pantalla</span>
  </div>`;
}

